import * as types from '../dashboardActionTypes';

export default (state = [], action) => {
    switch(action.type) {
        case types.LOAD_DEVICE_GROUPS_FAILED:
        case types.LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED:
        case types.LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED:
        case types.LOAD_SYSTEM_STATUS_FAILED:
        case types.LOAD_INCIDENTS_FAILED:
        case types.LOAD_LOGS_PER_DAY_FAILED:
        {
            const filteredErrors = state.filter(err => err.key !== action.type);
            return [
                ...filteredErrors,
                Object.assign({}, { key: action.type, message: action.message })
            ];
            }
        case types.LOAD_DEVICE_GROUPS_SUCCESS:
            return state.filter(err => err.key !== types.LOAD_DEVICE_GROUPS_FAILED);
        case types.LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS:
            return state.filter(err => err.key !== types.LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED);
        case types.LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS:
            return state.filter(err => err.key !== types.LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED);
        case types.LOAD_SYSTEM_STATUS_SUCCESS:
            return state.filter(err => err.key !== types.LOAD_SYSTEM_STATUS_FAILED);
        case types.LOAD_LOGS_PER_DAY_SUCCESS:
            return state.filter(err => err.key !== types.LOAD_LOGS_PER_DAY_FAILED);
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/dashboard/reducers/errorReducer.js